
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { Validate } from '@/types';
import PoweredByApp8 from '@/components/shared/PoweredByApp8.vue';
import PhoneNumberInput from '@/components/shared/PhoneNumberInput.vue';
import '@/validation-rules';

const namespace: string = 'auth';

@Component<ContactInformation>({
	components: {
		ValidationObserver,
		ValidationProvider,
		PoweredByApp8,
		PhoneNumberInput
	}
})
export default class ContactInformation extends Vue {
	@Prop({ type: Object, required: true, default: () => {} }) private userInfo!: UserInfo;
	@Prop({ type: String, required: true, default: () => '' }) private isLoading!: string;
	@Prop({ type: String, required: true, default: () => '' }) private email!: string;
	@Getter('showLoginAsBanner', { namespace }) private showLoginAsBanner!: boolean;

	$refs!: { observer: Validate };

	private contactInformation: UserContactInfo = {
		firstName: this.userInfo.firstName,
		lastName: this.userInfo.lastName,
		phoneNumber: this.userInfo.phoneNumber || ''
	 };

	private isRegisterFlow: boolean = this.$route.name === 'Login';

	private prev() {
		this.$emit('prev');
	}

	private async submit() {
		const isValid = await this.$refs.observer.validate();
		if (isValid) {
			this.$emit('next', this.contactInformation);
		}
	}
}
